// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useDispatch, useSelector } from 'react-redux';
import { getAPIErrorMessage } from 'api';
import { useCallback } from 'react';
export const useAppSelector = useSelector;
export function usePartialAppSelector(f, ...p1) {
    return useAppSelector((state) => f(state, ...p1));
}
const initial = (preload) => ({
    loading: false,
    loaded: false,
    error: null,
    data: preload,
});
export function createRequestReducerWithPreload(action_name, preload, err_msg) {
    return (state = initial(preload), action) => {
        switch (action.type) {
            case `${action_name}__REQUEST`:
                return {
                    ...state,
                    loaded: false,
                    loading: true,
                    error: null,
                };
            case `${action_name}__OK`:
                return {
                    ...state,
                    loading: false,
                    error: null,
                    loaded: true,
                    data: 'data' in action ? action.data : state.data,
                };
            case `${action_name}__FAIL`:
                return {
                    ...state,
                    loading: false,
                    error: 'error' in action && action.error
                        ? getAPIErrorMessage(action.error, err_msg ?? 'Ошибка')
                        : 'Ошибка стандартная',
                };
            default:
                return state;
        }
    };
}
export function createRequestReducer(action_name, err_msg) {
    // return createRequestReducerWithPreload<T, Str>(action_name, null, err_msg);
    return (state = initial(null), action) => {
        switch (action.type) {
            case `${action_name}__REQUEST`:
                return {
                    ...state,
                    loaded: false,
                    loading: true,
                    error: null,
                    data: null,
                };
            case `${action_name}__OK`:
                return {
                    ...state,
                    loading: false,
                    error: null,
                    loaded: true,
                    data: 'data' in action ? action.data : null,
                };
            case `${action_name}__FAIL`:
                return {
                    ...state,
                    loading: false,
                    error: 'error' in action && action.error
                        ? getAPIErrorMessage(action.error, err_msg ?? 'Ошибка')
                        : 'Ошибка стандартная',
                };
            default:
                return state;
        }
    };
}
/**
 * @function
 * @param action: функция, возвращающая action
 * @return мемоизированная функция, которая может обратиться к redux
 * useAction(f) --> dispatch(f())
 */
export function useAction(action) {
    const dispatch = useDispatch();
    return useCallback((...args) => dispatch(action(...args)), [dispatch, action]);
}
